var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-charts',{key:_vm.key,staticStyle:{"height":"100%"},attrs:{"options":_vm.options,"theme":"light","autoresize":true}})}
var staticRenderFns = []

export { render, staticRenderFns }